var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12.5087C27.5 10.0365 26.7668 7.61979 25.3933 5.56421C24.0198 3.50863 22.0676 1.90649 19.7835 0.960413C17.4995 0.0143317 14.9862 -0.23321 12.5614 0.249092C10.1367 0.731393 7.90941 1.92188 6.16125 3.67C4.99989 4.83155 4.07884 6.21059 3.45076 7.72831C2.82267 9.24603 2.49987 10.8727 2.5008 12.5152C2.50172 14.1577 2.82637 15.784 3.45617 17.301C4.08597 18.818 5.00858 20.196 6.17125 21.3562L12.4525 27.5H6.25V30H23.75V27.5H17.5475L23.8388 21.3462C25.0031 20.1885 25.9263 18.8113 26.5547 17.2943C27.1832 15.7773 27.5045 14.1507 27.5 12.5087ZM21.25 15.7725L15 18.8975L8.75 15.7725V7.9775L15 4.8525L21.25 7.9775V15.7725ZM15 11.25L18.75 9.375V14.2275L15 16.1025L11.25 14.2275V9.375L15 11.25Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a4f08fa3.svg";
export { ForwardRef as ReactComponent };